module.exports = __webpack_public_path__ + "img/824.f229098e.png";